/* eslint no-template-curly-in-string: ['off'] */
import { Predicate } from '@syncfusion/ej2-data';
import { Selector } from '@felicity/data-management';
import RoleDataSource from '../data/RoleDataSource.mjs';

/**
 * Selector for assessment tool records
 */
export default class RoleSelector extends Selector {
  textField = 'name';
  valueField = 'name';

  type = 'multiSelect';

  /* eslint class-methods-use-this: ['off'] */
  prepareFilter = (text, query) => {
    const predicate = new Predicate('name', 'contains', text, true)
      .or('normalizedName', 'contains', text, true);

    return query.where(predicate);
  };

  constructor() {
    super();

    this.dataSource = RoleDataSource.getDataSource();
  }
}

RoleSelector.register('role-selector');
